const X_AKAMAI_EDGESCAPE = 'x-akamai-edgescape';
export default function getAkamaiHeader(headers) {
  if (headers === void 0) {
    headers = {};
  }
  return headers[X_AKAMAI_EDGESCAPE];
}